export const moduleDescriptions = {
  MAGIC_SUGGESTIONS_MODULE: 'userGroups.module.magicSuggestionsModule',
  CORE_MODULE: 'userGroups.module.coreModule',
  NOTE_MODULE: 'userGroups.module.noteModule',
  ACTIVITY_MODULE: 'userGroups.module.activityModule',
  COACH_MODULE: 'userGroups.module.coachModule',
  PROGRESS_MODULE: 'userGroups.module.progressModule',
  CHAT_MODULE: 'userGroups.module.chatModule',
  NOTIFICATION_MODULE: 'userGroups.module.notificationModule',
  ACTIVITY_LIBRARY_MODULE: 'userGroups.module.activityLibraryModule',
  AQUARIUM_MODULE: 'userGroups.module.aquariumModule',
  CHAT_SUPPORT_MODULE: 'userGroups.module.chatSupportModule',
  CLIENT_ACTIVITY_MODULE: 'userGroups.module.personalizedActivityModule',
  BOOKING_MODULE: 'userGroups.module.bookingModule',
  TEAM_MODULE: 'userGroups.module.teamModule',
  CLIENT_GROUP_MODULE: 'userGroups.module.clientGroupModule',
};

export const userPermissionDescriptions = {
  COACH_MODULE_DELETE_COACH: 'userGroups.userPermissions.coachDelete',
  COACH_MODULE_CREATE_COACH: 'userGroups.userPermissions.coachCreate',
  COACH_MODULE_UPDATE_COACH_STATUS: 'userGroups.userPermissions.coachUpdateStatus',
  COACH_MODULE_VIEW_ACTIVE_COACHES: 'userGroups.userPermissions.coachViewActive',
  COACH_MODULE_VIEW_ARCHIVE_COACHES: 'userGroups.userPermissions.coachViewArchive',

  ACTIVITY_MODULE_VIEW_ACTIVITIES: 'userGroups.userPermissions.activityView',
  ACTIVITY_MODULE_ASSIGN_NEW_ACTIVITY: 'userGroups.userPermissions.activityAssignNew',
  ACTIVITY_MODULE_CHANGE_ACTIVITY_STATUS: 'userGroups.userPermissions.activityChangeStatus',
  ACTIVITY_MODULE_EDIT_ACTIVITY: 'userGroups.userPermissions.activityEdit',

  ACTIVITY_LIBRARY_MODULE_GET_ACTIVITY_LIBRARY: 'userGroups.userPermissions.activityLibraryGet',
  ACTIVITY_LIBRARY_MODULE_CREATE_ACTIVITY_LIBRARY:
    'userGroups.userPermissions.activityLibraryCreate',
  ACTIVITY_LIBRARY_MODULE_UPDATE_ACTIVITY_LIBRARY:
    'userGroups.userPermissions.activityLibraryUpdate',
  ACTIVITY_LIBRARY_MODULE_DELETE_ACTIVITY_LIBRARY:
    'userGroups.userPermissions.activityLibraryDelete',

  CORE_MODULE_VIEW_USER_GROUPS: 'userGroups.userPermissions.coreViewUserGroups',
  CORE_MODULE_GET_CLIENTS: 'userGroups.userPermissions.coreGetClients',
  CORE_MODULE_VIEW_ARCHIVE_CLIENTS: 'userGroups.userPermissions.coreViewArchiveClients',
  CORE_MODULE_CHANGE_CLIENT_STATUS: 'userGroups.userPermissions.coreChangeClientStatus',
  CORE_MODULE_ARCHIVE_CLIENTS: 'userGroups.userPermissions.coreArchiveClients',
  CORE_MODULE_ADD_NEW_CLIENT: 'userGroups.userPermissions.coreAddNewClient',
  CORE_MODULE_CHANGE_LANGUAGE: 'userGroups.userPermissions.coreChangeLanguage',
  CORE_MODULE_SEND_ACTIVITY_SUMMARY: 'userGroups.userPermissions.coreSendActivitySummary',
  CORE_MODULE_VIEW_SINGLE_CLIENT: 'userGroups.userPermissions.coreViewSingleClient',
  CORE_MODULE_VIEW_CLIENT_CONCENT: 'userGroups.userPermissions.coreViewClientConsent',
  CORE_MODULE_UPDATE_CLIENT_OBJECTIVES: 'userGroups.userPermissions.coreUpdateClientObjectives',
  CORE_MODULE_UPDATE_CLIENT_CONCENT: 'userGroups.userPermissions.coreUpdateClientConsent',
  CORE_MODULE_VIEW_APP_SETTINGS: 'userGroups.userPermissions.coreViewAppSettings',
  CORE_MODULE_UPDATE_APP_SETTINGS: 'userGroups.userPermissions.coreUpdateAppSettings',
  CORE_MODULE_COACH_DATA_REQUEST: 'userGroups.userPermissions.coreCoachDataRequest',
  CORE_MODULE_DELETE_COACH_ACCOUNT: 'userGroups.userPermissions.coreDeleteCoachAccount',

  PROGRESS_MODULE_GET_PROGRESS_SUMMARY: 'userGroups.userPermissions.progressGetProgressSummary',

  NOTIFICATION_MODULE_VIEW_NOTIFICATIONS:
    'userGroups.userPermissions.notificationViewNotifications',

  NOTE_MODULE_VIEW_NOTES: 'userGroups.userPermissions.noteViewNotes',
  NOTE_MODULE_CREATE_AND_EDIT_NOTES: 'userGroups.userPermissions.noteCreateAndEditNotes',
  NOTE_MODULE_DELETE_NOTES: 'userGroups.userPermissions.noteDeleteNotes',
  NOTE_MODULE_USE_RECORDING: 'userGroups.userPermissions.noteUseRecording',

  MAGIC_SUGGESTIONS_MODULE_GENERATE_SUGGESTIONS:
    'userGroups.userPermissions.magicSuggestionsGenerateSuggestions',
  MAGIC_SUGGESTIONS_MODULE_VIEW_SUGGESTIONS:
    'userGroups.userPermissions.magicSuggestionsViewSuggestions',

  CHAT_MODULE_VIEW_CHAT: 'userGroups.userPermissions.chatViewChat',
  CHAT_MODULE_SEND_MESSAGE: 'userGroups.userPermissions.chatSendMessage',

  AQUARIUM_MODULE_VIEW_AQUARIUM: 'userGroups.userPermissions.aquariumViewAquarium',
  AQUARIUM_MODULE_UPDATE_AQUARIUM: 'userGroups.userPermissions.aquariumUpdateAquarium',

  CHAT_SUPPORT_MODULE_PERMISSION: 'userGroups.userPermissions.chatSupportPermission',

  CLIENT_ACTIVITY_MODULE_UPDATE_ACTIVITY: 'userGroups.userPermissions.clientActivityUpdateActivity',
  CLIENT_ACTIVITY_MODULE_CREATE_ACTIVITY: 'userGroups.userPermissions.clientActivityCreateActivity',
  CLIENT_ACTIVITY_MODULE_DELETE_ACTIVITY: 'userGroups.userPermissions.clientActivityDeleteActivity',

  BOOKINGS_MODULE_VIEW_BOOKINGS: 'userGroups.userPermissions.bookingsViewBookings',
  BOOKINGS_MODULE_MANAGE_COACH_CONFIGURATIONS:
    'userGroups.userPermissions.bookingsManageCoachConfigurations',
  BOOKINGS_MODULE_VIEW_COACH_CONFIGURATIONS:
    'userGroups.userPermissions.bookingsViewCoachConfigurations',
  BOOKINGS_MODULE_MANAGE_BOOKINGS: 'userGroups.userPermissions.bookingsManageBookings',

  TEAM_MODULE_ARCHIVE_TEAM_MEMBER: 'userGroups.userPermissions.teamArchiveTeamMember',
  TEAM_MODULE_ADD_TEAM_MEMBER: 'userGroups.userPermissions.teamAddTeamMember',
  TEAM_MODULE_VIEW_COACH_GROUP: 'userGroups.userPermissions.teamViewCoachGroup',
  TEAM_MODULE_EDIT_TEAM_MEMBER: 'userGroups.userPermissions.teamEditTeamMember',

  // Client Group Module Permissions
  CLIENT_GROUP_MODULE_EDIT_CLIENT_GROUP: 'userGroups.userPermissions.clientGroupEditClientGroup',
  CLIENT_GROUP_MODULE_DELETE_CLIENT_GROUP:
    'userGroups.userPermissions.clientGroupDeleteClientGroup',
  CLIENT_GROUP_MODULE_VIEW_CLIENT_GROUP: 'userGroups.userPermissions.clientGroupViewClientGroup',
};
